import type { BrandCode } from '@/utils/resolveBrandCode'

const conventionBrandCodeBySlug: Record<string, BrandCode> = {
  'the-session-2027': 'VANISHING_INC_UK',
}

export type ConventionCurrencyDisplay = {
  id: number
  code: 'GBP' | 'USD'
  symbol: '£' | '$'
  brandCode: BrandCode
}

const conventionCurrencyByMetaId: Record<number, ConventionCurrencyDisplay> = {
  // Convention registration products use legacy event-market metadata:
  // The Session stores 1 for GBP/UK, while Magifest stores 2 for USD/US.
  1: {
    id: 1,
    code: 'GBP',
    symbol: '£',
    brandCode: 'VANISHING_INC_UK',
  },
  2: {
    id: 2,
    code: 'USD',
    symbol: '$',
    brandCode: 'VANISHING_INC_US',
  },
}

export const getConventionBrandCode = (
  conventionSlug: string | null | undefined
): BrandCode | null => {
  if (!conventionSlug) return null
  return conventionBrandCodeBySlug[conventionSlug] ?? null
}

export const conventionCurrencyFromMeta = (
  rawMetaValue: string | null | undefined
): ConventionCurrencyDisplay | null => {
  const parsed = Number(rawMetaValue)
  if (!Number.isFinite(parsed) || parsed <= 0) return null

  return conventionCurrencyByMetaId[parsed] ?? null
}
